import React from 'react';

const ContactUs = () => {
  return (
    <section className="section">
      <h2>Contact Us</h2>
      <p><b>Welcome to Dream College Path</b></p>
      <p>Email : <a href='mailto:info@dreamcollegepath.com'>info@dreamcollegepath.com</a></p>
      <p>Phone : <a href='tel:+19253077711'>+1 925-307-7711</a></p>
      <p>Address : 6200 Village Parkway, STE 200, Dublin, CA 94568</p>
    </section>
  );
};

export default ContactUs;
